module.exports = __webpack_public_path__ + "static/media/footer_img1.d9dd3cc5.svg";